const QueryParams = require('../../../page/frontend/helpers/params');

class SearchRetriever {
  constructor() {
    this.isInProgress = false;
  }

  get(params) {
    const url = `/browse/search/partial?${QueryParams.toString(params)}`;

    return fetch(url, { credentials: 'include' })
      .then(res =>
        res.status > 200 ? Promise.reject(res) : Promise.resolve(res)
      )
      .then(res => res.json());
  }
}

module.exports = SearchRetriever;
